import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import './LegalPage.css';

function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <SEO page="privacy" />
      <Header />

      <div className="legal-container">
        <div className="legal-content">
          <h1 className="legal-title">{t('legal.privacy.title', 'Privacy Policy')}</h1>
          <p className="legal-updated">{t('legal.privacy.lastUpdated', 'Last updated')}: January 2025</p>

          <section className="legal-section">
            <h2>{t('legal.privacy.introTitle', 'Introduction')}</h2>
            <p>{t('legal.privacy.introText', 'TraderMap ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website tradermap.io.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.collectTitle', 'Information We Collect')}</h2>
            <h3>{t('legal.privacy.autoCollectTitle', 'Automatically Collected Information')}</h3>
            <p>{t('legal.privacy.autoCollectText', 'When you visit our website, we may automatically collect certain information about your device, including:')}</p>
            <ul>
              <li>{t('legal.privacy.autoCollect1', 'Browser type and version')}</li>
              <li>{t('legal.privacy.autoCollect2', 'Operating system')}</li>
              <li>{t('legal.privacy.autoCollect3', 'IP address (anonymized)')}</li>
              <li>{t('legal.privacy.autoCollect4', 'Pages visited and time spent')}</li>
              <li>{t('legal.privacy.autoCollect5', 'Referring website')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.cookiesTitle', 'Cookies and Tracking')}</h2>
            <p>{t('legal.privacy.cookiesText', 'We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small data files stored on your device that help us:')}</p>
            <ul>
              <li>{t('legal.privacy.cookies1', 'Remember your preferences')}</li>
              <li>{t('legal.privacy.cookies2', 'Understand how you use our website')}</li>
              <li>{t('legal.privacy.cookies3', 'Improve our services')}</li>
              <li>{t('legal.privacy.cookies4', 'Provide analytics data')}</li>
            </ul>
            <p>{t('legal.privacy.cookiesControl', 'You can control cookies through your browser settings. Note that disabling cookies may affect some features of our website.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.useTitle', 'How We Use Your Information')}</h2>
            <p>{t('legal.privacy.useText', 'We use the collected information for the following purposes:')}</p>
            <ul>
              <li>{t('legal.privacy.use1', 'To operate and maintain our website')}</li>
              <li>{t('legal.privacy.use2', 'To improve and personalize your experience')}</li>
              <li>{t('legal.privacy.use3', 'To analyze usage patterns and trends')}</li>
              <li>{t('legal.privacy.use4', 'To detect and prevent technical issues')}</li>
              <li>{t('legal.privacy.use5', 'To comply with legal obligations')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.shareTitle', 'Information Sharing')}</h2>
            <p>{t('legal.privacy.shareText', 'We do not sell, trade, or rent your personal information to third parties. We may share anonymized, aggregated data with analytics providers to help us improve our services.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.securityTitle', 'Data Security')}</h2>
            <p>{t('legal.privacy.securityText', 'We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.retentionTitle', 'Data Retention')}</h2>
            <p>{t('legal.privacy.retentionText', 'We retain collected information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.rightsTitle', 'Your Rights')}</h2>
            <p>{t('legal.privacy.rightsText', 'Depending on your location, you may have certain rights regarding your personal information, including:')}</p>
            <ul>
              <li>{t('legal.privacy.rights1', 'The right to access your data')}</li>
              <li>{t('legal.privacy.rights2', 'The right to request correction of inaccurate data')}</li>
              <li>{t('legal.privacy.rights3', 'The right to request deletion of your data')}</li>
              <li>{t('legal.privacy.rights4', 'The right to opt-out of certain data processing')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.childrenTitle', 'Children\'s Privacy')}</h2>
            <p>{t('legal.privacy.childrenText', 'Our website is not intended for children under 18 years of age. We do not knowingly collect personal information from children.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.changesTitle', 'Changes to This Policy')}</h2>
            <p>{t('legal.privacy.changesText', 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('legal.privacy.contactTitle', 'Contact Us')}</h2>
            <p>{t('legal.privacy.contactText', 'If you have any questions about this Privacy Policy, please contact us at:')}</p>
            <p className="legal-contact">
              <a href="mailto:support@tradermap.io">support@tradermap.io</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
